/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import RequestReceiverSelectComponent from "./requestReceiverSelect.component";
import { selectLoading } from "modules/notification";
import RequestReceiverSelectPanelComponent from "./requestReceiverSelectPanel.component";
import { useSelector, useDispatch } from "react-redux";
import { cloneDeep } from "lodash";
import { getRequestReceiverDropdown } from "modules/stockflow/redux";

function RequestReceiverSelectContainer({
  handleChange,
  disabled,
  value,
  styles,
  textStyles,
  placeholder,
  type,
}) {
  const isFetching = useSelector((state) =>
    selectLoading(state, getRequestReceiverDropdown.typePrefix)
  );
  const requestReceiverDropdown = useSelector(
    (state) => state.stockflowRequestTransfer.requestReceiverDropdown
  );
  const lang = useSelector((state) => state.constant.languages);
  const [open, setOpen] = useState(false);
  const [isOpenList] = useState(false);
  const anchorRef = useRef(null);
  const prevOpen = useRef(open);
  const prevOpenList = useRef(isOpenList);
  const [selectAll, setSelectAll] = useState(false);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getRequestReceiverDropdown({
        search,
        is_my_request: type === "Send" ? 1 : 0,
      })
    );
  }, [search, dispatch]);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    if (prevOpenList.current === true && isOpenList === false) {
      anchorRef.current.focus();
    }

    prevOpenList.current = isOpenList;
  }, [isOpenList]);

  useEffect(() => {
    setSelectAll(value.length === requestReceiverDropdown.length);
  }, [value, requestReceiverDropdown]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSearch("");
  };

  const handleSelectAll = async () => {
    if (!selectAll) {
      let selectedReceiver = requestReceiverDropdown.map((p) => {
        return p.uuid;
      });
      handleChange(selectedReceiver);
    } else {
      handleChange([]);
    }
  };

  const handleSelectReceiver = (receiver) => {
    let temp = cloneDeep(value);

    if (temp.findIndex((t) => t === receiver.uuid) >= 0) {
      temp = temp.filter((t) => t !== receiver.uuid);
    } else {
      temp.push(receiver.uuid);
    }
    handleChange(temp);
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <>
      <RequestReceiverSelectComponent
        anchorRef={anchorRef}
        disabled={disabled}
        value={value}
        handleClick={handleOpen}
        styles={styles}
        textStyles={textStyles}
        placeholder={placeholder}
        lang={lang}
      />
      <RequestReceiverSelectPanelComponent
        selectAll={selectAll}
        value={value}
        anchorRef={anchorRef}
        open={open}
        isOpenList={isOpenList}
        handleClose={handleClose}
        isFetching={isFetching}
        requestReceiverDropdown={requestReceiverDropdown}
        handleSelectAll={handleSelectAll}
        handleSelectReceiver={handleSelectReceiver}
        handleSearch={handleSearch}
        lang={lang}
      />
    </>
  );
}

export default RequestReceiverSelectContainer;
